import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CardBundleDetails from './Card-Bundle-Details';

import './design.css';
import {
  FaArrowLeft, FaCheckCircle,
  FaTimesCircle, FaWhatsapp,
  FaSpinner, FaList, FaInbox, FaSearch, FaPhone
} from 'react-icons/fa';
import { ecardApi } from '../../api/eCards';
import { toast } from 'react-toastify';
import { handleApiResponse, showApiMessage } from '../../modals/global/ApiMessageModal/ApiMessageModal';
import Masonry from 'react-masonry-css';
import { Container, Form } from 'react-bootstrap';
import SpinnerLoader from '../../components/Buttons/SpinnerLoader';

const GeneratedWhatsAppCard = ({ onBack }) => {
  const navigate = useNavigate();
  const [filter, setFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [cardBatches, setCardBatches] = useState([]);

  // Debounce search term for API call
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  useEffect(() => {
    const trimmed = debouncedSearch.trim();
    if (trimmed.length === 0 || trimmed.length >= 3) {
      fetchCards(trimmed.length >= 3 ? trimmed : '');
    }
  }, [debouncedSearch]);

  const fetchCards = async (searchQuery = '') => {
    try {
      setLoading(true);
      const query = searchQuery.trim();
      const params = query.length >= 3 ? { search: query } : {};
      const response = await ecardApi.getGeneratedCards(params);

      let dataList = [];
      if (Array.isArray(response)) {
        dataList = response;
      } else if (Array.isArray(response?.data)) {
        dataList = response.data;
      } else if (Array.isArray(response?.data?.data)) {
        dataList = response.data.data;
      } else if (Array.isArray(response?.cards)) {
        dataList = response.cards;
      }

      const mappedBatches = dataList.map((batchData, index) => {
        const payment = batchData.payment || {};
        const isPaid = Number(batchData.payment_status) === 1 || Number(payment.payment_status) === 1;
        const bId = batchData.payment_id || payment.payment_id || `BND-${index}`;
        const cName = payment.customer_name || batchData.customer_fname || batchData.name || 'Pretty Card Batch';
        const cMobile = payment.customer_mobile || batchData.customer_mobile || batchData.mobile || '';

        const cardsCount = Array.isArray(batchData.cards) ? batchData.cards.length : (typeof batchData.cards === 'number' ? batchData.cards : 0);

        return {
          batchId: bId,
          coupleName: cName,
          customerMobile: cMobile,
          category: batchData.card_category || 'Invitation',
          eventType: batchData.event_type || 'Event',
          totalCards: cardsCount,
          templateId: batchData.template_id,
          templateName: batchData.name || 'Template',
          paymentStatus: isPaid ? 'paid' : 'unpaid',
          isPaid,
          amount: Number(batchData.total_amount || payment.amount || 0),
          paymentReference: payment.reference_number || '',
          templateImage: batchData.preview_path || ''
        };
      });

      setCardBatches(mappedBatches);

    } catch (err) {
      console.error('Error fetching generated cards:', err);
      handleApiResponse(err);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    if (onBack) return onBack();
    navigate(-1);
  };

  const breakpointColumnsObj = {
    default: 4,
    1100: 3,
    700: 2,
    500: 2
  };

  const filteredBatches = cardBatches.filter(b => {
    if (filter === 'paid') return b.isPaid;
    if (filter === 'unpaid') return !b.isPaid;
    return true;
  });

  const totalBatches = cardBatches.length;
  const paidBatches = cardBatches.filter(b => b.isPaid).length;
  const unpaidBatches = cardBatches.filter(b => !b.isPaid).length;

  return (
    <Container className="py-4">
      {/* Sleek Header */}
      <div className="position-relative d-flex justify-content-center align-items-center mb-4 mt-2" style={{ minHeight: '30px' }}>
        <button
          onClick={handleBack}
          className="position-absolute start-0"
          style={{
            background: 'transparent', border: 'none', padding: 0,
            display: 'flex', alignItems: 'center', color: '#64748b',
            cursor: 'pointer', transition: 'color 0.2s'
          }}
          onMouseEnter={(e) => e.currentTarget.style.color = '#4169e1'}
          onMouseLeave={(e) => e.currentTarget.style.color = '#64748b'}
        >
          <FaArrowLeft size={22} />
        </button>
        <h1 className="stylish-heading text-center mb-0" style={{ color: '#4169e1', letterSpacing: '3px' }}>Generated Cards</h1>
      </div>

      {loading ? (
        <SpinnerLoader />
      ) : (
        <>
          {/* Controls: Search and Filters Toolbar */}
          <div className="bg-white p-3 rounded-4 shadow-sm border mb-4 d-flex flex-column flex-sm-row justify-content-between align-items-stretch align-items-sm-center gap-3">
            {/* Search Bar */}
            <div className="position-relative flex-grow-1" style={{ maxWidth: '420px' }}>
              <FaSearch className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted" style={{ zIndex: 5 }} />
              <Form.Control
                type="text"
                placeholder="Tafuta kwa jina au namba..."
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
                className="ps-5 pe-4 shadow-none border"
                style={{ borderRadius: '25px', height: '42px', fontSize: '0.85rem', borderColor: '#e2e8f0' }}
              />
              {searchTerm && (
                <button
                  type="button"
                  onClick={() => setSearchTerm('')}
                  className="position-absolute top-50 end-0 translate-middle-y me-3 border-0 bg-transparent text-muted"
                  style={{ cursor: 'pointer', fontSize: '1.1rem', lineHeight: '1', zIndex: 5 }}
                  title="Futa utafutaji"
                >
                  &times;
                </button>
              )}
            </div>

            {/* Filter Pills */}
            <div className="d-flex align-items-center gap-2 overflow-auto" style={{ whiteSpace: 'nowrap' }}>
              {[
                { key: 'all', label: 'All', count: totalBatches },
                { key: 'paid', label: 'Paid', count: paidBatches },
                { key: 'unpaid', label: 'Unpaid', count: unpaidBatches },
              ].map(({ key, label, count }) => (
                <button
                  key={key}
                  type="button"
                  onClick={() => setFilter(key)}
                  className="btn btn-sm rounded-pill px-3 py-1.5 fw-semibold d-flex align-items-center gap-2"
                  style={{
                    border: '1px solid',
                    borderColor: filter === key ? '#4169e1' : '#e2e8f0',
                    backgroundColor: filter === key ? '#4169e1' : '#ffffff',
                    color: filter === key ? '#ffffff' : '#64748b',
                    fontSize: '0.83rem',
                    transition: 'all 0.2s ease',
                    height: '42px'
                  }}
                >
                  <span>{label}</span>
                  <span
                    className="badge rounded-pill"
                    style={{
                      backgroundColor: filter === key ? 'rgba(255,255,255,0.25)' : '#f1f5f9',
                      color: filter === key ? '#ffffff' : '#475569',
                      fontSize: '0.75rem',
                      fontWeight: 700
                    }}
                  >
                    {count}
                  </span>
                </button>
              ))}
            </div>
          </div>

          {filteredBatches.length === 0 ? (
            <div className="text-center py-5">
              <FaInbox size={40} color="#e2e8f0" style={{ marginBottom: '16px' }} />
              <p style={{ color: '#94a3b8', fontSize: '0.95rem' }}>No cards found.</p>
            </div>
          ) : (
            <Masonry
              breakpointCols={breakpointColumnsObj}
              className="my-masonry-grid"
              columnClassName="my-masonry-grid_column"
            >
              {filteredBatches.map(batch => {
                return (
                  <div
                    key={batch.batchId}
                    className="card-wrapper position-relative"
                    style={{ cursor: batch.isPaid ? 'pointer' : 'not-allowed', opacity: batch.isPaid ? 1 : 0.9 }}
                    onClick={() => {
                      if (!batch.isPaid) {
                        setShowPaymentModal(true);
                        return;
                      }
                      navigate(`/Generated-WhatsApp-Card/${batch.batchId}`, {
                        state: { batch, searchKeyword: searchTerm }
                      });
                    }}
                  >
                    {/* Paid/Unpaid tag */}
                    <div style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      backgroundColor: batch.isPaid ? '#10b981' : '#ef4444',
                      color: 'white',
                      padding: '3px 10px',
                      borderRadius: '20px',
                      fontSize: '0.78rem',
                      fontWeight: 'bold',
                      zIndex: 3,
                      boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px'
                    }}>
                      {batch.isPaid ? <FaCheckCircle size={10} /> : <FaTimesCircle size={10} />}
                      {batch.paymentStatus}
                    </div>

                    {/* Card count tag */}
                    <div className="price-tab d-flex align-items-center gap-2">
                      <span>{batch.totalCards} {batch.totalCards === 1 ? 'Card' : 'Cards'}</span>
                      <FaWhatsapp size={14} />
                    </div>

                    <img
                      src={batch.templateImage || 'https://via.placeholder.com/480x640?text=No+Preview'}
                      alt={batch.templateName}
                      className="card-img"
                      onError={e => { e.target.onerror = null; e.target.src = 'https://via.placeholder.com/480x640?text=No+Preview'; }}
                    />

                    {/* Info below image */}
                    <div style={{ padding: '10px 12px 14px' }}>
                      <div style={{ fontWeight: '700', fontSize: '0.95rem', color: '#1e293b', marginBottom: '2px' }}>
                        {batch.coupleName}
                      </div>
                      {batch.customerMobile && (
                        <div style={{ fontSize: '0.82rem', color: '#2563eb', fontWeight: '500', marginBottom: '4px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                          <FaPhone size={11} /> {batch.customerMobile}
                        </div>
                      )}
                      <div style={{ fontSize: '0.8rem', color: '#64748b', marginBottom: '6px' }}>
                        {batch.templateName} &bull; {batch.eventType}
                      </div>
                      <div className="gbw-card-footer d-flex justify-content-between align-items-center">
                        <span className="gbw-card-amount" style={{ fontWeight: '700', color: '#059669', fontSize: '0.9rem' }}>
                          TSH {batch.amount.toLocaleString()}
                        </span>
                        <span style={{ fontSize: '0.75rem', color: '#94a3b8' }}>
                          #{batch.batchId}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </Masonry>
          )}
        </>
      )}

      {/* Payment Modal */}
      {showPaymentModal && (
        <div className="modal-overlay" style={{
          position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
          backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
          justifyContent: 'center', alignItems: 'center', zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white', padding: '30px', borderRadius: '12px',
            maxWidth: '380px', width: '90%', textAlign: 'center'
          }}>
            <FaTimesCircle size={40} color="#ef4444" style={{ marginBottom: '12px' }} />
            <h4>Payment Required</h4>
            <p className="text-muted">Please complete payment to access this batch of cards.</p>
            <button
              onClick={() => setShowPaymentModal(false)}
              style={{
                background: '#4169e1', color: 'white', border: 'none',
                padding: '10px 28px', borderRadius: '30px', cursor: 'pointer',
                fontWeight: '600'
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </Container>
  );
};

export default GeneratedWhatsAppCard;